/* ====================================================================
   FLOOREVER — COMPARATIF DES GAMMES, MODE DUEL MOBILE
   (sections/floorever-comparatif.liquid — accueil)
   Vanilla JS, defer, aucune dépendance.

   Retour Christopher 10/07/2026 : le scroll latéral des 7 colonnes
   nuit à l'UX (mobile ET bureau). Sous 1100px (seuil où les 7
   colonnes tiennent dans le gabarit --maxw une fois resserrées),
   on ne montre donc que 2 colonnes, choisies par deux <select>
   NATIFS (défaut : entrée de gamme vs flagship) — le tableau tient
   plein écran, zéro geste latéral. Desktop : tableau complet,
   barre cachée. Sans JS : la barre reste hidden, repli = tableau
   défilant à colonne critères collante (état serveur).

   Mécanique : chaque th/td de colonne porte data-gamme (snippet
   comparatif-gammes) ; en mode duel le wrapper reçoit .cg-duel
   (CSS : colonnes masquées sauf .is-visible). Choisir dans un
   select la gamme déjà affichée en face = échange des deux
   (pattern swap, jamais deux colonnes identiques).
   ==================================================================== */
(function () {
  'use strict';

  function initUn(racine) {
    if (racine.dataset.cgInit === 'true') return;
    racine.dataset.cgInit = 'true';

    var scroll = racine.querySelector('.cg-scroll');
    var choix = racine.querySelector('[data-cg-choix]');
    var selects = racine.querySelectorAll('[data-cg-select]');
    if (!scroll || !choix || selects.length !== 2) return;

    var precedents = [selects[0].value, selects[1].value];
    var mq = window.matchMedia('(max-width: 1099px)'); /* sous le seuil où 7 colonnes tiennent dans --maxw */

    function appliquer() {
      var visibles = [selects[0].value, selects[1].value];
      var cellules = scroll.querySelectorAll('[data-gamme]');
      for (var i = 0; i < cellules.length; i++) {
        var c = cellules[i];
        if (visibles.indexOf(c.getAttribute('data-gamme')) !== -1) c.classList.add('is-visible');
        else c.classList.remove('is-visible');
      }
    }

    function surChangement(e) {
      var moi = e.target;
      var autre = moi === selects[0] ? selects[1] : selects[0];
      if (moi.value === autre.value) {
        /* la gamme est déjà en face : on échange */
        var idxMoi = moi === selects[0] ? 0 : 1;
        autre.value = precedents[idxMoi];
      }
      precedents = [selects[0].value, selects[1].value];
      appliquer();
    }

    function mode() {
      var duel = mq.matches;
      choix.hidden = !duel;
      if (duel) {
        scroll.classList.add('cg-duel');
        appliquer();
      } else {
        scroll.classList.remove('cg-duel');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', surChangement); });
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', mode);
    else if (typeof mq.addListener === 'function') mq.addListener(mode);
    mode();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-comparatif]').forEach(initUn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
}());
